import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {AttributeVocabularyPref} from '../constants';

export const attributeVocabulariesEnabled = () =>
	getPreference(AttributeVocabularyPref.ENABLED, true);

export default attributeVocabulariesEnabled;
